/**
 * API Client - Axios Instance
 * Configuração centralizada com interceptors
 */

import axios from 'axios';

const apiClient = axios.create({
    baseURL: import.meta.env.VITE_API_URL || 'http://localhost:3001',
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json',
    },
});

/**
 * Request Interceptor
 * Adiciona token automaticamente em todas as requisições
 */
apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('bacbo_auth_token');

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        console.error('❌ [Request Error]:', error);
        return Promise.reject(error);
    }
);

/**
 * Response Interceptor
 * Trata erros globalmente (ex: logout em 401)
 */
apiClient.interceptors.response.use(
    (response) => {
        // if (import.meta.env.DEV) {
        // 	console.log(`✅ [API Response]: ${response.config.method?.toUpperCase()} ${response.config.url} - ${response.status}`);
        // }
        return response;
    },
    (error) => {
        console.error(`❌ [API Error]: ${error.config?.method?.toUpperCase()} ${error.config?.url} - ${error.response?.status}`);

        // 401 Unauthorized - Token inválido/expirado
        if (error.response?.status === 401) {
            const url = String(error.config?.url || "");
            if (url.includes("/api/telemetry/")) {
                return Promise.reject(error);
            }
            console.warn('🔒 Token inválido ou expirado. Fazendo logout...');
            localStorage.removeItem('bacbo_auth_token');
            localStorage.removeItem('bacbo_user');

            if (typeof window !== 'undefined') {
                window.location.href = '/landing';
            }
        }

        return Promise.reject(error);
    }
);

export default apiClient;
